<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="green">
          <template slot="header">
            <md-icon>today</md-icon>
          </template>

          <template slot="content">
            <p class="category">Attendance</p>
            <h4 class="title">{{this.$store.state.user.attendance}}</h4>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>date_range</md-icon>
              <router-link to='meetings'>Sign in to meeting...</router-link>
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>person</md-icon>
          </template>

          <template slot="content">
            <p class="category">Trading Rank</p>
            <h4 class="title">
              {{tradingRank}}
            </h4>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>list</md-icon>
              <router-link to='rankings'>See full rankings...</router-link>
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="red">
          <template slot="header">
            <md-icon>assignment</md-icon>
          </template>

          <template slot="content">
            <p class="category">Positions Held</p>
            <h4 class="title">{{positionsHeld}}</h4>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>history</md-icon>
              <router-link to='positions'>See position history...</router-link>
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="blue">
          <template slot="header">
            <md-icon>attach_money</md-icon>
          </template>

          <template slot="content">
            <p class="category">Portfolio Balance</p>
            <h4 class="title">{{`$${formatNumber(portfolioTotal)}`}}</h4>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>autorenew</md-icon>
              Just Updated
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
        <md-card>
          <md-card-header data-background-color="orange">
            <h4 class="title">Current Positions</h4>
          </md-card-header>
          <md-card-content>
            <div class="logo-img">
              <img :src='tradingImg' alt=''>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Quick Actions</h4>
            <p class="category"></p>
          </md-card-header>
          <md-card-content>
            <quick-actions-table></quick-actions-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <md-snackbar :md-duration="Infinity" :md-active.sync="showSnackbar">
      <span>Become a paid USIT member today!</span>
      <md-button class="md-success" @click="snackbarGo">GO</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import {
  StatsCard,
  ChartCard,
  NavTabsCard,
  NavTabsTable,
  OrderedTable,
  QuickActionsTable
} from "@/components";

import CurrentPositionsTable from "@/pages/Trading/CurrentPositionsDash.vue";
import axios from 'axios';

export default {
  components: {
    StatsCard,
    ChartCard,
    NavTabsCard,
    NavTabsTable,
    OrderedTable,
    CurrentPositionsTable,
    QuickActionsTable
  },
  data() {
    return {
      showSnackbar: false,
      tradingRank: 'N/A',
      positionsHeld: 0,
      portfolioTotal: 'N/A',
    };
  },
  props: {
    tradingImg: {
      type: String,
      default: require("@/assets/img/currentPositionsBlur.png")
    }
  },
  mounted() {
    this.refreshData();
  },
  created() {
    if (!this.$store.state.isPaid) {
      this.showSnackbar = true;
    }
  },
  methods: {
    snackbarGo() {
      this.showSnackbar = false;
      this.$router.push('payment');
    },
    refreshData() {
      axios.get(`/api/trading/member_portfolio_dash/${this.$store.state.user.id}`)
      .then((res) => {
        this.positionsHeld = res.data.position_count;
        this.portfolioTotal = res.data.total;
        this.tradingRank = res.data.rank;
      }).catch((err) => {

      });
    },
    formatNumber(n) {
      var parts=n.toString().split(".");
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
    }
  },
};
</script>

<style scoped>
  router-link {
    font-size: 150%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue